<template>
    <div class="layout">
        <navigation :lang="this.lang" v-if="this.$route.name != 'Root'"></navigation>
        <router-view />
        <menu-footer :lang="this.lang"  v-if="this.$route.name != 'Root'"></menu-footer>
    </div>
</template>

<script>
  import Navigation from './Navigation';
  import MenuFooter from './MenuFooter';

  export default {
    name: 'Layout',
    props: ['lang'],
    components: {
      Navigation,
      MenuFooter,
    },
  };
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .layout {
        background: url('../assets/website_bg.jpg') fixed;
        background-position: center center;
        width: 1280px;
        max-width: 100%;
    }

    .layout > div {
        padding:1rem 2rem;
    }

    .menu-footer {
        bottom:0rem;
        line-height: 2rem;
        width:100%;
        z-index: 20;
    }

</style>



// WEBPACK FOOTER //
// src/components/Layout.vue